import { GET_PROJECTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import {
	MY_PROJECTS_LIST_MODULE_ID, MY_PROJECT_BANNER_HEADER_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes'
import { VIEW_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { cardListType } from 'root/src/shared/constants/moduleTypes'

export default {
	[MY_PROJECTS_LIST_MODULE_ID]: {
		moduleType: 'list',
		listType: cardListType,
		listPayload: {
			pageItemLength: 8,
		},
		recordType: project,
		endpointId: [GET_PROJECTS],
		listRouteId: VIEW_PROJECT_ROUTE_ID,
		sortFilterModule: MY_PROJECT_BANNER_HEADER_MODULE_ID,
		goTopButton: true,
	},
}
